export default {
  statisticsApiUrl: process.env.GATSBY_API_URL,
  hostname: process.env.GATSBY_APP_HOSTNAME,
}
